export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_18.301230c5.jpg";